import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { DocumentAttachmentDetailDto } from "apis/data-contracts";
import ViewerAttachmentItem from "./DocumentDetailAttachmentItem";

export interface DocumentDetailViewerAttachmentListProps {
  attachmentList: DocumentAttachmentDetailDto[];
}

const DocumentDetailViewerAttachmentList = ({
  attachmentList,
}: DocumentDetailViewerAttachmentListProps) => {
  const hasOriginAttachment = attachmentList.some(
    (attachment) => !attachment.isAdditional,
  );
  const hasAdditionalAttachment = attachmentList.some(
    (attachment) => attachment.isAdditional,
  );

  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "2mm",
        overflow: "hidden",
      }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "3.175mm",
        }}
      >
        {hasOriginAttachment && (
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              gap: "2mm",
            }}
          >
            <View style={{ width: "20mm", paddingTop: "1mm" }}>
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "10pt",
                  fontWeight: 400,
                  alignItems: "flex-start",
                  flexShrink: 0,
                }}
              >
                첨부파일
              </Text>
            </View>

            <View
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2mm",
                flex: 1,
              }}
            >
              {attachmentList.map(
                (attachment) =>
                  !attachment.isAdditional && (
                    <ViewerAttachmentItem
                      key={attachment.uuid}
                      fileName={attachment.fileName}
                    />
                  ),
              )}
            </View>
          </View>
        )}

        {hasAdditionalAttachment && (
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              gap: "2mm",
            }}
          >
            <View style={{ width: "20mm", paddingTop: "1mm" }}>
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "10pt",
                  fontWeight: 400,
                  alignItems: "flex-start",
                  flexShrink: 0,
                }}
              >
                추가 첨부파일
              </Text>
            </View>

            <View
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2mm",
                flex: 1,
              }}
            >
              {attachmentList.map(
                (attachment) =>
                  attachment.isAdditional && (
                    <ViewerAttachmentItem
                      key={attachment.uuid}
                      fileName={attachment.fileName}
                    />
                  ),
              )}
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

export default DocumentDetailViewerAttachmentList;
